var cov_mvsrdkid0 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/utils/numbers.ts",
      hash = "fdd9dda2d2616eebd281168509b06ccd8a4ee473",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/utils/numbers.ts",
    statementMap: {
      "0": {
        start: {
          line: 2,
          column: 16
        },
        end: {
          line: 2,
          column: 27
        }
      },
      "1": {
        start: {
          line: 3,
          column: 2
        },
        end: {
          line: 5,
          column: 3
        }
      },
      "2": {
        start: {
          line: 4,
          column: 4
        },
        end: {
          line: 4,
          column: 63
        }
      },
      "3": {
        start: {
          line: 6,
          column: 2
        },
        end: {
          line: 6,
          column: 66
        }
      },
      "4": {
        start: {
          line: 6,
          column: 56
        },
        end: {
          line: 6,
          column: 65
        }
      },
      "5": {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 12,
          column: 3
        }
      },
      "6": {
        start: {
          line: 11,
          column: 4
        },
        end: {
          line: 11,
          column: 67
        }
      },
      "7": {
        start: {
          line: 13,
          column: 15
        },
        end: {
          line: 13,
          column: 16
        }
      },
      "8": {
        start: {
          line: 14,
          column: 17
        },
        end: {
          line: 14,
          column: 18
        }
      },
      "9": {
        start: {
          line: 15,
          column: 17
        },
        end: {
          line: 23,
          column: 4
        }
      },
      "10": {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 20,
          column: 5
        }
      },
      "11": {
        start: {
          line: 17,
          column: 16
        },
        end: {
          line: 17,
          column: 25
        }
      },
      "12": {
        start: {
          line: 18,
          column: 6
        },
        end: {
          line: 18,
          column: 17
        }
      },
      "13": {
        start: {
          line: 19,
          column: 6
        },
        end: {
          line: 19,
          column: 14
        }
      },
      "14": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 21,
          column: 17
        }
      },
      "15": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 22,
          column: 15
        }
      },
      "16": {
        start: {
          line: 25,
          column: 2
        },
        end: {
          line: 28,
          column: 4
        }
      },
      "17": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 26,
          column: 33
        }
      },
      "18": {
        start: {
          line: 26,
          column: 12
        },
        end: {
          line: 26,
          column: 33
        }
      },
      "19": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 20
        }
      },
      "20": {
        start: {
          line: 32,
          column: 2
        },
        end: {
          line: 32,
          column: 48
        }
      },
      "21": {
        start: {
          line: 36,
          column: 2
        },
        end: {
          line: 38,
          column: 3
        }
      },
      "22": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 37,
          column: 29
        }
      },
      "23": {
        start: {
          line: 41,
          column: 2
        },
        end: {
          line: 43,
          column: 3
        }
      },
      "24": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 42,
          column: 16
        }
      },
      "25": {
        start: {
          line: 45,
          column: 2
        },
        end: {
          line: 50,
          column: 3
        }
      },
      "26": {
        start: {
          line: 53,
          column: 14
        },
        end: {
          line: 53,
          column: 28
        }
      },
      "27": {
        start: {
          line: 55,
          column: 2
        },
        end: {
          line: 55,
          column: 56
        }
      },
      "28": {
        start: {
          line: 58,
          column: 17
        },
        end: {
          line: 58,
          column: 31
        }
      },
      "29": {
        start: {
          line: 60,
          column: 2
        },
        end: {
          line: 68,
          column: 3
        }
      },
      "30": {
        start: {
          line: 61,
          column: 20
        },
        end: {
          line: 61,
          column: 66
        }
      },
      "31": {
        start: {
          line: 63,
          column: 25
        },
        end: {
          line: 63,
          column: 48
        }
      },
      "32": {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 66,
          column: 5
        }
      },
      "33": {
        start: {
          line: 65,
          column: 6
        },
        end: {
          line: 65,
          column: 41
        }
      },
      "34": {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 67,
          column: 20
        }
      },
      "35": {
        start: {
          line: 70,
          column: 2
        },
        end: {
          line: 70,
          column: 101
        }
      },
      "36": {
        start: {
          line: 74,
          column: 17
        },
        end: {
          line: 74,
          column: 44
        }
      },
      "37": {
        start: {
          line: 75,
          column: 2
        },
        end: {
          line: 75,
          column: 38
        }
      },
      "38": {
        start: {
          line: 75,
          column: 28
        },
        end: {
          line: 75,
          column: 38
        }
      },
      "39": {
        start: {
          line: 76,
          column: 2
        },
        end: {
          line: 78,
          column: 3
        }
      },
      "40": {
        start: {
          line: 77,
          column: 4
        },
        end: {
          line: 77,
          column: 34
        }
      },
      "41": {
        start: {
          line: 80,
          column: 2
        },
        end: {
          line: 82,
          column: 3
        }
      },
      "42": {
        start: {
          line: 81,
          column: 4
        },
        end: {
          line: 81,
          column: 34
        }
      },
      "43": {
        start: {
          line: 83,
          column: 24
        },
        end: {
          line: 83,
          column: 84
        }
      },
      "44": {
        start: {
          line: 84,
          column: 2
        },
        end: {
          line: 84,
          column: 46
        }
      }
    },
    fnMap: {
      "0": {
        name: "range",
        decl: {
          start: {
            line: 1,
            column: 16
          },
          end: {
            line: 1,
            column: 21
          }
        },
        loc: {
          start: {
            line: 1,
            column: 46
          },
          end: {
            line: 7,
            column: 1
          }
        },
        line: 1
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 6,
            column: 45
          },
          end: {
            line: 6,
            column: 46
          }
        },
        loc: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 65
          }
        },
        line: 6
      },
      "2": {
        name: "split",
        decl: {
          start: {
            line: 9,
            column: 16
          },
          end: {
            line: 9,
            column: 21
          }
        },
        loc: {
          start: {
            line: 9,
            column: 53
          },
          end: {
            line: 29,
            column: 1
          }
        },
        line: 9
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 15,
            column: 26
          },
          end: {
            line: 15,
            column: 27
          }
        },
        loc: {
          start: {
            line: 15,
            column: 31
          },
          end: {
            line: 23,
            column: 3
          }
        },
        line: 15
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 25,
            column: 20
          },
          end: {
            line: 25,
            column: 21
          }
        },
        loc: {
          start: {
            line: 25,
            column: 25
          },
          end: {
            line: 28,
            column: 3
          }
        },
        line: 25
      },
      "5": {
        name: "toPrecision",
        decl: {
          start: {
            line: 31,
            column: 16
          },
          end: {
            line: 31,
            column: 27
          }
        },
        loc: {
          start: {
            line: 31,
            column: 57
          },
          end: {
            line: 33,
            column: 1
          }
        },
        line: 31
      },
      "6": {
        name: "validateNumber",
        decl: {
          start: {
            line: 35,
            column: 16
          },
          end: {
            line: 35,
            column: 30
          }
        },
        loc: {
          start: {
            line: 35,
            column: 45
          },
          end: {
            line: 51,
            column: 1
          }
        },
        line: 35
      },
      "7": {
        name: "isE",
        decl: {
          start: {
            line: 52,
            column: 16
          },
          end: {
            line: 52,
            column: 19
          }
        },
        loc: {
          start: {
            line: 52,
            column: 37
          },
          end: {
            line: 56,
            column: 1
          }
        },
        line: 52
      },
      "8": {
        name: "getNumberPrecision",
        decl: {
          start: {
            line: 57,
            column: 16
          },
          end: {
            line: 57,
            column: 34
          }
        },
        loc: {
          start: {
            line: 57,
            column: 52
          },
          end: {
            line: 71,
            column: 1
          }
        },
        line: 57
      },
      "9": {
        name: "sub",
        decl: {
          start: {
            line: 73,
            column: 16
          },
          end: {
            line: 73,
            column: 19
          }
        },
        loc: {
          start: {
            line: 73,
            column: 48
          },
          end: {
            line: 85,
            column: 1
          }
        },
        line: 73
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 1,
            column: 35
          },
          end: {
            line: 1,
            column: 44
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 1,
            column: 43
          },
          end: {
            line: 1,
            column: 44
          }
        }],
        line: 1
      },
      "1": {
        loc: {
          start: {
            line: 3,
            column: 2
          },
          end: {
            line: 5,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 3,
            column: 2
          },
          end: {
            line: 5,
            column: 3
          }
        }, {
          start: {
            line: 3,
            column: 2
          },
          end: {
            line: 5,
            column: 3
          }
        }],
        line: 3
      },
      "2": {
        loc: {
          start: {
            line: 3,
            column: 6
          },
          end: {
            line: 3,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 3,
            column: 6
          },
          end: {
            line: 3,
            column: 31
          }
        }, {
          start: {
            line: 3,
            column: 35
          },
          end: {
            line: 3,
            column: 54
          }
        }],
        line: 3
      },
      "3": {
        loc: {
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 12,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 12,
            column: 3
          }
        }, {
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 12,
            column: 3
          }
        }],
        line: 10
      },
      "4": {
        loc: {
          start: {
            line: 10,
            column: 6
          },
          end: {
            line: 10,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 10,
            column: 6
          },
          end: {
            line: 10,
            column: 31
          }
        }, {
          start: {
            line: 10,
            column: 35
          },
          end: {
            line: 10,
            column: 46
          }
        }],
        line: 10
      },
      "5": {
        loc: {
          start: {
            line: 16,
            column: 4
          },
          end: {
            line: 20,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 16,
            column: 4
          },
          end: {
            line: 20,
            column: 5
          }
        }, {
          start: {
            line: 16,
            column: 4
          },
          end: {
            line: 20,
            column: 5
          }
        }],
        line: 16
      },
      "6": {
        loc: {
          start: {
            line: 26,
            column: 4
          },
          end: {
            line: 26,
            column: 33
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 26,
            column: 4
          },
          end: {
            line: 26,
            column: 33
          }
        }, {
          start: {
            line: 26,
            column: 4
          },
          end: {
            line: 26,
            column: 33
          }
        }],
        line: 26
      },
      "7": {
        loc: {
          start: {
            line: 31,
            column: 41
          },
          end: {
            line: 31,
            column: 55
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 31,
            column: 53
          },
          end: {
            line: 31,
            column: 55
          }
        }],
        line: 31
      },
      "8": {
        loc: {
          start: {
            line: 36,
            column: 2
          },
          end: {
            line: 38,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 36,
            column: 2
          },
          end: {
            line: 38,
            column: 3
          }
        }, {
          start: {
            line: 36,
            column: 2
          },
          end: {
            line: 38,
            column: 3
          }
        }],
        line: 36
      },
      "9": {
        loc: {
          start: {
            line: 41,
            column: 2
          },
          end: {
            line: 43,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 41,
            column: 2
          },
          end: {
            line: 43,
            column: 3
          }
        }, {
          start: {
            line: 41,
            column: 2
          },
          end: {
            line: 43,
            column: 3
          }
        }],
        line: 41
      },
      "10": {
        loc: {
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 49,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 47,
            column: 45
          }
        }, {
          start: {
            line: 48,
            column: 4
          },
          end: {
            line: 48,
            column: 39
          }
        }, {
          start: {
            line: 49,
            column: 4
          },
          end: {
            line: 49,
            column: 39
          }
        }],
        line: 47
      },
      "11": {
        loc: {
          start: {
            line: 55,
            column: 9
          },
          end: {
            line: 55,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 55,
            column: 9
          },
          end: {
            line: 55,
            column: 35
          }
        }, {
          start: {
            line: 55,
            column: 39
          },
          end: {
            line: 55,
            column: 56
          }
        }],
        line: 55
      },
      "12": {
        loc: {
          start: {
            line: 60,
            column: 2
          },
          end: {
            line: 68,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 60,
            column: 2
          },
          end: {
            line: 68,
            column: 3
          }
        }, {
          start: {
            line: 60,
            column: 2
          },
          end: {
            line: 68,
            column: 3
          }
        }],
        line: 60
      },
      "13": {
        loc: {
          start: {
            line: 64,
            column: 4
          },
          end: {
            line: 66,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 64,
            column: 4
          },
          end: {
            line: 66,
            column: 5
          }
        }, {
          start: {
            line: 64,
            column: 4
          },
          end: {
            line: 66,
            column: 5
          }
        }],
        line: 64
      },
      "14": {
        loc: {
          start: {
            line: 64,
            column: 8
          },
          end: {
            line: 64,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 64,
            column: 8
          },
          end: {
            line: 64,
            column: 20
          }
        }, {
          start: {
            line: 64,
            column: 24
          },
          end: {
            line: 64,
            column: 39
          }
        }],
        line: 64
      },
      "15": {
        loc: {
          start: {
            line: 70,
            column: 9
          },
          end: {
            line: 70,
            column: 101
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 70,
            column: 58
          },
          end: {
            line: 70,
            column: 97
          }
        }, {
          start: {
            line: 70,
            column: 100
          },
          end: {
            line: 70,
            column: 101
          }
        }],
        line: 70
      },
      "16": {
        loc: {
          start: {
            line: 70,
            column: 9
          },
          end: {
            line: 70,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 70,
            column: 9
          },
          end: {
            line: 70,
            column: 29
          }
        }, {
          start: {
            line: 70,
            column: 33
          },
          end: {
            line: 70,
            column: 55
          }
        }],
        line: 70
      },
      "17": {
        loc: {
          start: {
            line: 75,
            column: 2
          },
          end: {
            line: 75,
            column: 38
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 75,
            column: 2
          },
          end: {
            line: 75,
            column: 38
          }
        }, {
          start: {
            line: 75,
            column: 2
          },
          end: {
            line: 75,
            column: 38
          }
        }],
        line: 75
      },
      "18": {
        loc: {
          start: {
            line: 76,
            column: 2
          },
          end: {
            line: 78,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 76,
            column: 2
          },
          end: {
            line: 78,
            column: 3
          }
        }, {
          start: {
            line: 76,
            column: 2
          },
          end: {
            line: 78,
            column: 3
          }
        }],
        line: 76
      },
      "19": {
        loc: {
          start: {
            line: 80,
            column: 2
          },
          end: {
            line: 82,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 80,
            column: 2
          },
          end: {
            line: 82,
            column: 3
          }
        }, {
          start: {
            line: 80,
            column: 2
          },
          end: {
            line: 82,
            column: 3
          }
        }],
        line: 80
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

export function range(end) {
  var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_mvsrdkid0.b[0][0]++, 0);
  cov_mvsrdkid0.f[0]++;
  var delta = (cov_mvsrdkid0.s[0]++, end - start);
  cov_mvsrdkid0.s[1]++;

  if ((cov_mvsrdkid0.b[2][0]++, typeof delta !== 'number') || (cov_mvsrdkid0.b[2][1]++, Number.isNaN(delta))) {
    cov_mvsrdkid0.b[1][0]++;
    cov_mvsrdkid0.s[2]++;
    console.error(new Error('end can not computed with start'));
  } else {
    cov_mvsrdkid0.b[1][1]++;
  }

  cov_mvsrdkid0.s[3]++;
  return Array.from({
    length: end - start
  }, function (_v, k) {
    cov_mvsrdkid0.f[1]++;
    cov_mvsrdkid0.s[4]++;
    return k + start;
  });
}
export function split(total, nums) {
  cov_mvsrdkid0.f[2]++;
  cov_mvsrdkid0.s[5]++;

  if ((cov_mvsrdkid0.b[4][0]++, typeof total !== 'number') || (cov_mvsrdkid0.b[4][1]++, total === 0)) {
    cov_mvsrdkid0.b[3][0]++;
    cov_mvsrdkid0.s[6]++;
    console.error(new Error('total mast be a number(not equal 0)'));
  } else {
    cov_mvsrdkid0.b[3][1]++;
  }

  var remain = (cov_mvsrdkid0.s[7]++, 1);
  var nilCount = (cov_mvsrdkid0.s[8]++, 0);
  var ratios = (cov_mvsrdkid0.s[9]++, nums.map(function (n) {
    cov_mvsrdkid0.f[3]++;
    cov_mvsrdkid0.s[10]++;

    if (n) {
      cov_mvsrdkid0.b[5][0]++;
      var r = (cov_mvsrdkid0.s[11]++, n / total);
      cov_mvsrdkid0.s[12]++;
      remain -= n;
      cov_mvsrdkid0.s[13]++;
      return r;
    } else {
      cov_mvsrdkid0.b[5][1]++;
    }

    cov_mvsrdkid0.s[14]++;
    nilCount += 1;
    cov_mvsrdkid0.s[15]++;
    return null;
  }));
  cov_mvsrdkid0.s[16]++;
  return ratios.map(function (r) {
    cov_mvsrdkid0.f[4]++;
    cov_mvsrdkid0.s[17]++;

    if (!r) {
      cov_mvsrdkid0.b[6][0]++;
      cov_mvsrdkid0.s[18]++;
      r = remain / nilCount;
    } else {
      cov_mvsrdkid0.b[6][1]++;
    }

    cov_mvsrdkid0.s[19]++;
    return total * r;
  });
}
export function toPrecision(num) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_mvsrdkid0.b[7][0]++, 12);
  cov_mvsrdkid0.f[5]++;
  cov_mvsrdkid0.s[20]++;
  return +parseFloat(num.toPrecision(precision));
}
export function validateNumber(num) {
  cov_mvsrdkid0.f[6]++;
  cov_mvsrdkid0.s[21]++;

  if (typeof num === 'number') {
    cov_mvsrdkid0.b[8][0]++;
    cov_mvsrdkid0.s[22]++;
    return !Number.isNaN(num);
  } else {
    cov_mvsrdkid0.b[8][1]++;
  } // Empty


  cov_mvsrdkid0.s[23]++;

  if (!num) {
    cov_mvsrdkid0.b[9][0]++;
    cov_mvsrdkid0.s[24]++;
    return false;
  } else {
    cov_mvsrdkid0.b[9][1]++;
  }

  cov_mvsrdkid0.s[25]++;
  return (// Normal type: 11.28
    (cov_mvsrdkid0.b[10][0]++, /^\s*-?\d+(\.\d+)?\s*$/.test(String(num))) || (cov_mvsrdkid0.b[10][1]++, // Pre-number: 1.
    /^\s*-?\d+\.\s*$/.test(String(num))) || (cov_mvsrdkid0.b[10][2]++, // Post-number: .1
    /^\s*-?\.\d+\s*$/.test(String(num)))
  );
}
export function isE(number) {
  cov_mvsrdkid0.f[7]++;
  var str = (cov_mvsrdkid0.s[26]++, String(number));
  cov_mvsrdkid0.s[27]++;
  return (cov_mvsrdkid0.b[11][0]++, !Number.isNaN(Number(str))) && (cov_mvsrdkid0.b[11][1]++, str.includes('e'));
}
export function getNumberPrecision(number) {
  cov_mvsrdkid0.f[8]++;
  var numStr = (cov_mvsrdkid0.s[28]++, String(number));
  cov_mvsrdkid0.s[29]++;

  if (isE(number)) {
    cov_mvsrdkid0.b[12][0]++;
    var precision = (cov_mvsrdkid0.s[30]++, Number(numStr.slice(numStr.indexOf('e-') + 2)));
    var decimalMatch = (cov_mvsrdkid0.s[31]++, numStr.match(/\.(\d+)/));
    cov_mvsrdkid0.s[32]++;

    if ((cov_mvsrdkid0.b[14][0]++, decimalMatch) && (cov_mvsrdkid0.b[14][1]++, decimalMatch[1])) {
      cov_mvsrdkid0.b[13][0]++;
      cov_mvsrdkid0.s[33]++;
      precision += decimalMatch[1].length;
    } else {
      cov_mvsrdkid0.b[13][1]++;
    }

    cov_mvsrdkid0.s[34]++;
    return precision;
  } else {
    cov_mvsrdkid0.b[12][1]++;
  }

  cov_mvsrdkid0.s[35]++;
  return (cov_mvsrdkid0.b[16][0]++, numStr.includes('.')) && (cov_mvsrdkid0.b[16][1]++, validateNumber(numStr)) ? (cov_mvsrdkid0.b[15][0]++, numStr.length - numStr.indexOf('.') - 1) : (cov_mvsrdkid0.b[15][1]++, 0);
}
export function sub(num1, num2) {
  cov_mvsrdkid0.f[9]++;
  var number = (cov_mvsrdkid0.s[36]++, Number(num1) + Number(num2));
  cov_mvsrdkid0.s[37]++;

  if (Number.isNaN(number)) {
    cov_mvsrdkid0.b[17][0]++;
    cov_mvsrdkid0.s[38]++;
    return NaN;
  } else {
    cov_mvsrdkid0.b[17][1]++;
  }

  cov_mvsrdkid0.s[39]++;

  if (number > Number.MAX_SAFE_INTEGER) {
    cov_mvsrdkid0.b[18][0]++;
    cov_mvsrdkid0.s[40]++;
    return Number.MAX_SAFE_INTEGER;
  } else {
    cov_mvsrdkid0.b[18][1]++;
  }

  cov_mvsrdkid0.s[41]++;

  if (number < Number.MIN_SAFE_INTEGER) {
    cov_mvsrdkid0.b[19][0]++;
    cov_mvsrdkid0.s[42]++;
    return Number.MIN_SAFE_INTEGER;
  } else {
    cov_mvsrdkid0.b[19][1]++;
  }

  var maxPrediction = (cov_mvsrdkid0.s[43]++, Math.max(getNumberPrecision(num1), getNumberPrecision(num2)));
  cov_mvsrdkid0.s[44]++;
  return Number(number.toFixed(maxPrediction));
}